import {PlaybookExampleDto} from "../dto/PlaybookExampleDto";

export const sortExamples = (
    examples: PlaybookExampleDto[],
    sortBy: 'name' | null,
    sortDirection: 'asc' | 'desc'
): PlaybookExampleDto[] => {
    if (!sortBy) return [...examples];

    return [...examples].sort((a, b) => {
        let aValue: string;
        let bValue: string;

        switch (sortBy) {
            case 'name':
                aValue = a.displayName;
                bValue = b.displayName;
                break;
            default:
                return 0;
        }

        if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
        return 0;
    });
};